export interface MarketingConsent {
  optionCode: string;
  optionName: string;
  optionTerm: string;
  termMimeType: string;
}
